import { useState, useEffect } from 'react';
import { fieldValidator } from '../../utils/yupSchemaCreator';
import { FormControl, Textarea } from '@airbus/components-react';

export default function FieldTextarea(props) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    handleEnterTabBlur,
  } = props;
  const [value, setValue] = useState(initialValues[name] ?? '');
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (initialValues) {
      setValue(initialValues[name]);
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }

      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const error = fieldValidator(field, newValue, language);
    setError(error);
    if (
      (!error || newValue === '') &&
      (newValue.length >= field.attrMinValue || field.attrMinValue === null) &&
      (newValue.length <= field.attrMaxValue || field.attrMaxValue === null)
    ) {
      setValue(e.target.value);
    }
  };

  const handleFocus = () => {
    setTouched(true);
  };

  const handleBlur = () => {
    if (initialValues[name] === value) {
      return;
    }
    blurHandler(name, value);
    if (field?.onValueChange) {
      field.onValueChange({ rowId, value, row: initialValues });
    }
  };
  return (
    <FormControl
      id={name}
      error={touched && Boolean(error)}
      {...{ label, required }}
      helpText={touched && error?.msg}
      errorText={touched && error?.msg}
      className='input-small disabled-input'
    >
      <Textarea
        rows={3}
        {...{ name, readOnly: disabled }}
        value={value ?? ''}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleEnterTabBlur}
        onFocus={handleFocus}
      />
    </FormControl>
  );
}
